import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import SEO from '../lib/SEO';

export default function NotFound() {
  return (
    <section className="container-aqc py-24 text-center">
      <SEO title="Page Not Found | Apex Quality Control" description="The page you were looking for isn’t here." />
      <div className="font-serif text-6xl text-aqc-red">404</div>
      <h1 className="mt-4 font-serif text-4xl text-aqc-navy">Page not found.</h1>
      <p className="mt-4 text-aqc-muted max-w-md mx-auto">The page you were looking for isn’t here — but we can still help.</p>
      <div className="mt-6 flex flex-wrap gap-3 justify-center">
        <Link to="/"><Button className="bg-aqc-navy hover:bg-[hsl(var(--aqc-navy-2))] text-white">Back to home</Button></Link>
        <Link to="/services"><Button variant="outline">See services</Button></Link>
        <Link to="/contact"><Button variant="outline">Contact us</Button></Link>
      </div>
    </section>
  );
}
